import { FormControl } from '@angular/forms';
import {
  MCGRSettlementScopeFormGroup,
  SettlementScope,
  SettlementScopeDto,
} from '../costs-section/costs-section-form.model';

export enum MCGRNewRequestOtherSourceSettlementScopeControlName {
  Source = 'source',
}

export interface MCGROtherSourceSettlementScopeFormGroup
  extends MCGRSettlementScopeFormGroup {
  [MCGRNewRequestOtherSourceSettlementScopeControlName.Source]: FormControl<string>;
}

export interface OtherSourceSettlementScope extends SettlementScope {
  [MCGRNewRequestOtherSourceSettlementScopeControlName.Source]: string;
}

export class OtherSourceSettlementScopeDto extends SettlementScopeDto {
  constructor(
    public Zrodlo: string,
    ZakresRzeczowy: string,
    Kwota?: number,
    UdzialProcent?: number,
  ) {
    super(ZakresRzeczowy, Kwota, UdzialProcent);
  }

  static override fromAppToApi(
    data: OtherSourceSettlementScope,
  ): OtherSourceSettlementScopeDto {
    return new this(data.source, data.scope, data.amount, data.percentageShare);
  }
}
